module.exports = __webpack_public_path__ + "img/nomad10.3c8c7c91.jpg";